{
  "colorSwatchPicker": "Muestras de colores",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Seleccionar un artículo",
  "tableResizer": "Cambiador de tamaño"
}
